import React from 'react'

export default function Service(props) {
  return (
    <div className='service'>
        <img src={props.img}/>
        <div className='service-desc'>
            <h3>{props.title}</h3>
            <p>{props.text}</p>
        </div>
    </div>
  )
}
